export default __webpack_public_path__ + "static/media/PREWEDDING_compressed.e7a790e1.png";